import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

const NAV_HEIGHT = {
  MOBILE: '50px',
  TABLET: '80px',
  DESKTOP: '100px',
};

export const style: any = (styles: IGenericObject) => {
  const { isVerticalBranding, windowStatus, isNavStatic } = styles;
  return StyleSheet.create({
    header: {
      display: isVerticalBranding ? 'none' : 'block',
      position: isNavStatic ? 'initial' : 'fixed',
      width: '100%',
      zIndex: 100,
      background: isVerticalBranding || !windowStatus ? 'transparent' : palette.black,
      padding: '20px',

      [media.tablet]: {
        padding: '15px 20px',
      },
      [media.desktop]: {
        padding: '9px 20px',
      },
    },

    topLevel: {
      display: 'flex',
    },

    nav: {
      display: 'flex',
      justifyContent: isVerticalBranding ? 'center' : 'space-between',
      alignItems: 'center',
      width: '100%',
      height: isVerticalBranding ? 'auto' : NAV_HEIGHT.MOBILE,
      color: '#FFF',
      position: 'relative',
      maxWidth: '980px',
      margin: '0 auto',

      [media.tablet]: {
        height: isVerticalBranding ? 'auto' : NAV_HEIGHT.TABLET,
      },

      [media.desktop]: {
        height: isVerticalBranding ? 'auto' : NAV_HEIGHT.DESKTOP,
      },

      [children('.welcome-text')]: {
        [media.desktop]: {
          display: 'block',
        },

        [media.xl]: {
          display: 'inline',
        },
      },
      [children('> .is-list')]: {
        display: 'none',

        ':hover': {
          [children('ul')]: {
            display: 'block',
          },
        },
        [media.tablet]: {
          display: 'flex',
        },
      },
    },

    hamburger: {
      position: 'relative',
      margin: '15px 0px 15px 20px',

      ':hover': {
        cursor: 'pointer',
      },

      [children('span')]: {
        width: 20,
        height: 2,
        backgroundColor: '#ecf0f1',
        display: 'block',
        margin: '4px auto',
        transition: 'all 0.3s ease-in-out',
      },

      [media.tablet]: {
        display: 'none',
      },
    },
    activeHamburger: {
      [children('span') + ':nth-of-type(1)']: {
        transform: 'translateY(6px) rotate(45deg)',
      },
      [children('span') + ':nth-of-type(2)']: {
        opacity: 0,
      },
      [children('span') + ':nth-of-type(3)']: {
        transform: 'translateY(-6px) rotate(-45deg)',
      },
    },

    dropdownContainer: {
      position: 'absolute',
      zIndex: 10000,
      top: 'calc(100% + 2px)',
      width: 'fit-content',
      display: 'block',

      [media.desktop]: {
        top: 'calc(80% - 1px)',
      },
    },

    noWrap: {
      display: 'block',
      whiteSpace: 'nowrap',
    },

    subtitle: {
      [media.desktop]: {
        display: 'block',
        marginTop: 5,
      },
    },
  });
};
